import BlogThirtyEightContainer from "./container/BlogThirtyEightContainer";

export default BlogThirtyEightContainer;
